import { fromJS } from 'immutable';

export const CHECK = 'kroost/giftcards/CHECK';
export const CHECKED = 'kroost/giftcards/CHECKED';

// Initial routing state
const initialState = fromJS({
  checking: false,
  code: null,
  valid: [],
  invalid: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CHECK:
      return state.set('checking', true);
    case CHECKED:
      return state
        .set('code', action.valid ? action.code : null)
        .update(action.valid ? 'valid' : 'invalid', items => items.push(action.code))
        .set('checking', false);
    default:
      return state;
  }
}

export function check(code) {
  return {
    type: CHECK,
    code,
  };
}

export function checked(code, valid = false) {
  return {
    type: CHECKED,
    code,
    valid,
  };
}



// WEBPACK FOOTER //
// ./app/redux/reducers/giftcards.js